import React from 'react'

const SvgLinkedIn = props => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="currentColor" {...props}>
    <path d="M27 11a2 2 0 012 2v14a2 2 0 01-2 2H13a2 2 0 01-2-2V13a2 2 0 012-2h14zm-.5 15.5v-5.3c0-1.8-1.46-3.26-3.26-3.26-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 011.4 1.4v4.93h2.79zm-11.62-9.94a1.686 1.686 0 000-3.37 1.69 1.69 0 00-1.69 1.69c0 .93.76 1.68 1.69 1.68zm1.39 9.94v-8.37H13.5v8.37h2.77z" />
  </svg>
)

export default SvgLinkedIn
